import styled from '@emotion/styled'
import { fonts } from '../../__styling/settings/fonts'
import { calcRem } from '../../__styling/style-functions/calc-rem'

export const StyledMoreTitle = styled('h2')({
    fontSize: calcRem(18),
    fontFamily: fonts.sevennews.sansSerifCond,
    textTransform: 'uppercase',
    marginBottom: calcRem(18),
})
